export const defaultProps = {
    dropdownProps: {
        position: "bottom",
    },
};
